import { render, staticRenderFns } from "./MediaProjectCloseTask.vue?vue&type=template&id=7c53570b&scoped=true"
import script from "./MediaProjectCloseTask.vue?vue&type=script&lang=js"
export * from "./MediaProjectCloseTask.vue?vue&type=script&lang=js"
import style0 from "./MediaProjectCloseTask.vue?vue&type=style&index=0&id=7c53570b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c53570b",
  null
  
)

export default component.exports